// Navbar.jsx
import React, { useState } from "react";
import { AppBar, Toolbar, Box, Typography, Tabs, Tab } from "@mui/material";
import Avatar from "@mui/material/Avatar";

// Optional: you can replace this with an <img> tag for real logo
function Logo() {
  return (
    <img src="pfglogo.png" alt="Logo" style={{ height: 30, width: 100 }} />
  );
}

// UPDATED: “Marketing Prep” → “Meeting Prep”
const TAB_CONFIG = [
  { label: "Account Research", value: "core" },
  { label: "Account Planning", value: "account" },
  { label: "Meeting Prep", value: "marketing" }, // ✅ renamed
];

export default function Navbar({
  activeTab: controlledValue,
  onTabChange,
  screen,
  onHome,
}) {
  const [internalValue, setInternalValue] = useState("core");

  const value = controlledValue ?? internalValue;

  const handleChange = (event, newValue) => {
    setInternalValue(newValue);
    if (onTabChange) onTabChange(newValue);
  };

  return (
    <AppBar
      position="fixed"
      elevation={2}
      sx={{
        borderRadius: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: "linear-gradient(135deg, #002147 0%, #003366 100%)",
      }}
    >
      <Toolbar
        sx={{
          minHeight: 56,
          px: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        {/* LEFT: Logo + App Name */}
        <Box
          onClick={onHome}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 1,
            minWidth: 0,
          }}
        >
          <Logo />
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: 500,
              letterSpacing: 0.3,
              color: "#ffffff",
            }}
          >
            Institutional Client Intelligence
          </Typography>
        </Box>

        {/* CENTER: Tabs */}
        {screen !== 0 && (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="inherit"
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                minHeight: 48,
              }}
            >
              {TAB_CONFIG.map((tab) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  label={tab.label}
                  sx={{
                    minHeight: 48,
                    px: 3,
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    color: "rgba(255,255,255,0.85)",
                    "&.Mui-selected": {
                      backgroundColor: "transparent !important",
                      color: "#ffffff",
                      textDecoration: "underline",
                      textUnderlineOffset: 6,
                      textDecorationThickness: "2px",
                    },
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: "#ffffff",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>
        )}

        {/* RIGHT: Avatar */}
        <Box sx={{ ml: 3, cursor: "pointer" }}>
          <Avatar
            sx={{
              width: 36,
              height: 36,
              bgcolor: "#90caf9", // Light Blue
              color: "#003366", // Dark navy text
              fontWeight: 700,
              fontSize: "1rem",
              boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
            }}
          >
            U
          </Avatar>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
